module.exports = __webpack_public_path__ + "static/media/offer.c63de64b.pdf";